import {
  MOON_250,
  MOON_500,
  THEME,
} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
Container.displayName = 'S.Container';

export const ArtifactPathContainer = styled.div`
  margin-top: 8px;
  border: 1px solid light-dark(${MOON_250}, ${THEME.border});
  border-radius: 4px;
  gap: 1px;
  display: flex;
  flex-direction: column;
`;
ArtifactPathContainer.displayName = 'S.ArtifactPathContainer';

export const DropdownItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 4px;
  border-bottom: 1px solid light-dark(${MOON_250}, ${THEME.border});

  &:last-child {
    border-bottom: none;
  }
`;
DropdownItem.displayName = 'S.DropdownItem';

export const DropdownItemLabelText = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${THEME.textPrimary};
`;
DropdownItemLabelText.displayName = 'S.DropdownItemLabelText';

export const OptionLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
OptionLabel.displayName = 'S.OptionLabel';

export const OptionaLabelText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${THEME.textPrimary};
`;
OptionaLabelText.displayName = 'S.OptionaLabelText';

export const OptionLabelSubtitleText = styled.div`
  font-size: 14px;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
OptionLabelSubtitleText.displayName = 'S.OptionLabelSubtitleText';

export const DisabledDropdownContainer = styled.div`
  width: 100%;
`;
DisabledDropdownContainer.displayName = 'S.DisabledDropdownContainer';
